export const tissVersions = {
  40100: '4.01.00',
  40200: '4.02.00',
};

export function getName(value) {
  return tissVersions[value];
}
